import styled, { keyframes } from "styled-components";

const glow = keyframes`
  from {
    text-shadow: 0 0 5x #c22323, 0 0 7px #c22323, 0 0 9px #c22323;
  }
  to {
    text-shadow: 0 0 7px #c22323, 0 0 9px #c22323, 0 0 11px #c22323;
  }
`;

export const Navbar = styled.div`
  display: flex;
  flex-flow: row wrap;
  justify-content: space-between;
  align-items: center;
`;

export const RoomNavbarContainer = styled.div`
  display: flex;
  flex-flow: column wrap;
  justify-content: center;
  align-items: center;
  margin: 0 3rem;
`;

export const Title = styled.div`
  font-family: "Cinzel", serif;
  font-size: 2em;
  color: #d0021b;
  animation: ${glow} 1.5s ease-in-out infinite alternate;
  text-align: center;
  margin-top: 0.5em;

  @media only screen and (max-width: 500px) {
    font-size: 1.25em;
  }

  @media only screen and (max-width: 375px) {
    font-size: 1em;
  }
`;

export const SimpleText = styled.div`
  font-family: "Cinzel", serif;
  font-size: 1.25em;
  color: white;
  text-align: center;
  margin-top: 0.25em;

  @media only screen and (max-width: 500px) {
    font-size: 1.125em;
  }

  @media only screen and (max-width: 375px) {
    font-size: 0.75em;
  }
`;

export const Token = styled.div`
  font-weight: Bold;
  font-size: 1.25em;
  color: white;
  text-align: center;
  margin-top: 0.25em;

  @media only screen and (max-width: 500px) {
    font-size: 1.125em;
  }

  @media only screen and (max-width: 375px) {
    font-size: 0.75em;
  }
`;

export const Button = styled.button`
  outline: none;
  cursor: pointer;
  transition-duration: 0.1s;
  border: none;
  font-weight: 700;
  background-color: #b80016;
  color: white;
  margin: 0.5em;
  width: 10em;
  height: 2.5em;
  border-radius: 16px;
  &:disabled {
    cursor: default;
    background-color: #969696;
    color: #c7c7c7;
  }
  &:hover:enabled {
    background-color: #ff001f;
    box-shadow: 0 2px 3px #999;
  }
  &:active:enabled {
    box-shadow: 0 0px 2px #666;
    background-color: #ff001f;
    transform: translateY(1px);
  }

  @media only screen and (max-width: 1370px) {
    width: 7em;
  }

  @media only screen and (max-width: 500px) {
    width: 8.5em;
    height: 2.25em;
    font-size: 1em;
  }

  @media only screen and (max-width: 375px) {
    width: 8.25em;
    height: 2.125em;
    font-size: 0.9em;
  }
`;
